module.exports = __webpack_public_path__ + "img/header.311f90b.png";